import axios from "axios";

const DesignLanding = async (jtoken, vtoken, designId) => {
  try {
    const result = await axios.get(
      `${process.env.REACT_APP_HOST}visitor/design/${designId}`,
      {
        headers: {
          jtoken,
          vtoken,
        },
      }
    );

    return result;
  } catch (error) {
    return false;
  }
};

export default DesignLanding;
